import styled from 'styled-components';
import { Form } from 'react-bootstrap';

export const FieldGroupStyled = styled(Form.Group)`
  position: relative;

  opacity: 1;
  z-index: 1;
`;
